import React from "react";
import DocsCards from "./DocsCards";

const handleDownload = async (uri, nombre) => {
  const { handleDownloadBlob  } = useGetBlobs();
  try
  {
    await handleDownloadBlob(uri, nombre); 
  } 
  catch {
    toast.error("No se pudo descargar el archivo.");
  }
};

const DocumentsAuthorizationsGrid = ({ documents }) => (
  <DocsCards
    items={documents ?? []}
    getName={(d) => d.Nombre ?? d.nombre ?? ""}
    getDate={(d) => d.fecha}
    onDownload={(d) => handleDownload(d.Uri ?? d.uri, d.Nombre ?? d.nombre)}
    emptyMessage="No hay documentos de autorizaciones."
  />
);

export default DocumentsAuthorizationsGrid;
